/**
 *
 * @param {number} value
 * @param {string} unit
 * @returns {string}
 */
const formatMoney = (value, unit) => {
  return `${value.toLocaleString('en-US')}${unit || ''}`.trim()
}

export { formatMoney }
